import style from './style.module.scss'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Header, Icon, Stack } from '@crossfit/ui'
import { Button } from '@crossfit/design-system'
import {
  BioFormProps,
  FormData,
} from 'components/Admin/ContactInfo/forms/Bio/schema'
import { useMediaQuery } from 'hooks/useMediaQuery'
import { useFormNotification } from 'hooks/useFormNotification'
import ErrorWrapper from 'components/Admin/Shared/Form/ErrorWrapper'
import Form from 'components/Admin/Shared/Form'
import { patchAffiliate } from 'services/affiliates'

export const BioForm = (props: BioFormProps) => {
  const { affiliate, setIsEditing } = props
  const handleFormNotification = useFormNotification()
  const isMobile = useMediaQuery('(max-width: 900px)')

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    mode: 'onBlur',
  })

  const cancel = (e) => {
    e.preventDefault()
    setIsEditing(false)
  }

  const onSubmit = handleSubmit(async ({ bio }) => {
    try {
      const patchResponse = await patchAffiliate(affiliate.id, {
        bio: bio,
      })

      if (patchResponse.status < 300) {
        props.update(bio)
        reset({ bio })
        handleFormNotification('success')
        setIsEditing(false)
      }
    } catch (error) {
      const errorDetail =
        JSON.parse(error?.request?.response ?? {})?.detail ??
        'Something went wrong'
      handleFormNotification('error', { message: errorDetail })
    }
  })

  useEffect(() => {
    reset({ bio: affiliate.bio })
  }, [affiliate.id])

  return (
    <div className={style.wrapper}>
      <Form id={'form-id-bio'} className={style.formWrapper}>
        {isMobile && (
          <div className={style.formHeader}>
            <Icon
              name='chevron'
              className={style.chevron}
              height={16}
              width={16}
              onClick={(e) => cancel(e)}
            />
            <Header as='h3' size='small' className={style.header}>
              {'Bio'}
            </Header>
          </div>
        )}
        <Stack
          className={style.formInputs}
          direction={['horizontal', 'vertical']}
          spacing={6}
        >
          <Stack direction='vertical'>
            <ErrorWrapper
              showError={!!errors?.bio}
              errorMessage={errors?.bio?.message}
            >
              <textarea
                id='bio'
                placeholder='Enter Bio'
                required={false}
                {...register('bio', { required: false })}
                className={style.textArea}
              />
            </ErrorWrapper>
          </Stack>
        </Stack>
        <div className={style.formButtons}>
          {!isMobile && (
            <Button size='sm' variant='secondary' onClick={(e) => cancel(e)}>
              Cancel
            </Button>
          )}
          <Button size='sm' variant='primary' onClick={handleSubmit(onSubmit)}>
            Save
          </Button>
        </div>
      </Form>
    </div>
  )
}
